import React, { useState } from 'react';
import View from './view';
import CPPUtils from 'services/CPPUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import { setFormValues } from 'hooks/useReduxForm';

const DEFAULT_ARRAY: any[] = [];

const AdministeredDrugsCard = ({
  patient,
  onClose,
  hideTopBar = false,
}: {
  patient: any;
  onClose?: () => void;
  hideTopBar?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const drugs =
    useAppSelector((state) => state.healthRecords.byId[patient.id]?.administered_drugs) ||
    DEFAULT_ARRAY;

  const [collapsed, setCollapsed] = useState(true);

  const formName = CPPUtils.getFormName('administered_drugs', patient.id);

  function resetForm() {
    onEdit({});
  }

  function onEdit(drug: any) {
    setCollapsed(false);
    dispatch(
      setFormValues({
        formName,
        values: CPPUtils.getImmunizationEditElement(drug),
      }),
    );
  }

  function onReadminister(drug: any) {
    setCollapsed(false);
    let value = CPPUtils.getImmunizationEditElement({
      ...drug,
      value: {
        ...drug.value,
        id: undefined,
        lot: undefined,
        given_date: undefined,
        expiry_date: undefined,
        given_by: undefined,
      },
    });
    dispatch(
      setFormValues({
        formName,
        values: value,
      }),
    );
  }

  async function onDelete(drug: any) {
    await dispatch(
      api.HealthRecords.removeAdministeredDrug({
        id: drug.id,
        patientId: patient.id,
      }),
    );
  }

  return (
    <View
      /*@ts-ignore*/
      collapsed={collapsed}
      patient={patient}
      drugs={drugs}
      onClose={onClose}
      onDelete={onDelete}
      onEdit={onEdit}
      onReadminister={onReadminister}
      resetForm={resetForm}
      form={formName}
      setCollapsed={setCollapsed}
      hideTopBar={hideTopBar}
    />
  );
};

export default AdministeredDrugsCard;
